import styles from '../../pages/home_page/Hero.module.scss';

export const Line = () => {
    return (
        <svg width="2" height="252" viewBox="0 0 2 252" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.line}>
            <path d="M1 0.296387V95.2964" stroke="#FF4286"/>
            <path d="M1 106.296V126.296" stroke="#FF4286"/>
            <path d="M1 137.296V157.296" stroke="#FF4286"/>
            <path d="M1 168.296V173.296" stroke="#FF4286"/>
            <path d="M1 184.296V204.296" stroke="#FF4286"/>
            <path d="M1 215.296V220.296" stroke="#FF4286"/>
            <path d="M1 231.296V251.296" stroke="#FF4286"/>
        </svg>  
    )
}